<div class="container-fluid">
    <app-page-title title="Landing Page"></app-page-title>

        <div class="row col-lg-12">
            <app-page-title title="Dashboard"></app-page-title>
        </div>

        <div class ="row">
            <div class=" col-lg-4" *ngIf="checkAccess('view')">
                <div class="button-items col-lg-12">
                    <button type="button" class="btn btn-block btn-outline-primary w-sm" [routerLink]="['/dashboard']" style="height: 8rem; font-size:21px;">
                        <i class="bx bx-bar-chart d-block" style="font-size: 47px;font-weight: bold;"></i> Estate Dashboard
                    </button>
                </div>

            </div>
           
                <div class=" col-lg-4" *ngIf="checkAccessMill('view')">
                    <div class="button-items col-lg-12">

                        <button type="button" class="btn btn-block btn-outline-primary w-sm" [routerLink]="['/milldashboard']" style="height: 8rem; font-size:21px;">
                            <i class="bx bx-bar-chart-alt-2 d-block" style="font-size: 47px; font-weight: bold;"></i> Mill Dashboard
                        </button>
                    </div> 
                </div>
                <div class=" col-lg-4" >
                </div>
        </div> 
        
</div>